"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useInsightExport = void 0;
var tslib_1 = require("tslib");
// (C) 2021-2022 GoodData Corporation
var react_1 = require("react");
var ts_invariant_1 = tslib_1.__importDefault(require("ts-invariant"));
var sdk_ui_ext_1 = require("@gooddata/sdk-ui-ext");
var uuid_1 = require("uuid");
var model_1 = require("../../../model");
var useExportHandler_1 = require("./useExportHandler");
var dashboardContexts_1 = require("../../dashboardContexts");
exports.useInsightExport = function (config) {
    var title = config.title, widgetRef = config.widgetRef, insight = config.insight;
    var _a = tslib_1.__read(react_1.useState(false), 2), isExporting = _a[0], setIsExporting = _a[1];
    var dispatch = model_1.useDashboardDispatch();
    var exportFunction = react_1.useCallback(function (configToUse) {
        return model_1.dispatchAndWaitFor(dispatch, model_1.exportInsightWidget(widgetRef, tslib_1.__assign(tslib_1.__assign({}, configToUse), { format: configToUse.format === "xlsx" ? "xlsx" : "csv" }), uuid_1.v4())).then(function (result) { return result.payload.resultUri; });
    }, [widgetRef]);
    var isInsightExportable = sdk_ui_ext_1.getInsightVisualizationMeta(insight).supportsExport;
    var isExportableToCsv = model_1.useDashboardSelector(model_1.selectIsExecutionResultExportableToCsvByRef(widgetRef));
    var isExportableToXlsx = model_1.useDashboardSelector(model_1.selectIsExecutionResultExportableToXlsxByRef(widgetRef));
    var settings = model_1.useDashboardSelector(model_1.selectSettings);
    var exportHandler = useExportHandler_1.useExportHandler();
    var _b = dashboardContexts_1.useExportDialogContext(), openDialog = _b.openDialog, closeDialog = _b.closeDialog;
    var onExportCSV = react_1.useCallback(function () {
        setIsExporting(true);
        var exportConfig = {
            format: "csv",
            title: title,
        };
        // if this bombs there is an issue with the logic enabling the buttons
        ts_invariant_1.default(exportFunction);
        exportHandler(exportFunction, exportConfig).then(function () { return setIsExporting(false); });
    }, [exportFunction, title]);
    var onExportXLSX = react_1.useCallback(function () {
        var _a, _b, _c;
        openDialog({
            onSubmit: function (_a) {
                var includeFilterContext = _a.includeFilterContext, mergeHeaders = _a.mergeHeaders;
                setIsExporting(true);
                // if this bombs there is an issue with the logic enabling the buttons
                ts_invariant_1.default(exportFunction);
                closeDialog();
                exportHandler(exportFunction, {
                    format: "xlsx",
                    mergeHeaders: mergeHeaders,
                    includeFilterContext: includeFilterContext,
                    showFilters: includeFilterContext,
                    title: title,
                }).then(function () { return setIsExporting(false); });
            },
            includeFilterContext: Boolean((_a = settings === null || settings === void 0 ? void 0 : settings.activeFiltersByDefault) !== null && _a !== void 0 ? _a : true),
            mergeHeaders: Boolean((_b = settings === null || settings === void 0 ? void 0 : settings.cellMergedByDefault) !== null && _b !== void 0 ? _b : true),
            filterContextVisible: Boolean((_c = settings === null || settings === void 0 ? void 0 : settings.enableActiveFilterContext) !== null && _c !== void 0 ? _c : true),
        });
    }, [settings, title, exportFunction, closeDialog]);
    var exportCSVEnabled = !isExporting && isInsightExportable && isExportableToCsv;
    var exportXLSXEnabled = !isExporting && isInsightExportable && isExportableToXlsx;
    return {
        exportCSVEnabled: exportCSVEnabled,
        exportXLSXEnabled: exportXLSXEnabled,
        onExportCSV: onExportCSV,
        onExportXLSX: onExportXLSX,
    };
};
//# sourceMappingURL=useInsightExport.js.map